/**
 * 认证 API
 */
import { api } from './client.js';

export const authAPI = {
  /**
   * 用户登录
   */
  async login(credentials) {
    try {
      const response = await api.post('/auth/login', {
        email: credentials.email || credentials.phone,
        password: credentials.password,
      });

      if (response.data && response.data.token) {
        api.setToken(response.data.token);
      }

      return response;
    } catch (error) {
      console.error('Login failed:', error);
      throw error;
    }
  },

  /**
   * 用户注册
   */
  async register(userData) {
    try {
      const response = await api.post('/auth/register', userData);

      if (response.data && response.data.token) {
        api.setToken(response.data.token);
      }

      return response;
    } catch (error) {
      console.error('Registration failed:', error);
      throw error;
    }
  },

  /**
   * 用户登出
   */
  async logout() {
    try {
      await api.post('/auth/logout');
      api.clearToken();
    } catch (error) {
      console.error('Logout failed:', error);
      // 即使失败也清除本地token
      api.clearToken();
    }
  },

  /**
   * 获取当前会话
   */
  async getSession() {
    try {
      return await api.get('/auth/session');
    } catch (error) {
      // 401 is expected when user is not logged in - not an error
      if (error.status !== 401 && error.message !== 'Unauthorized') {
        console.error('Get session failed:', error);
      }
      return null;
    }
  },

  /**
   * 刷新token
   */
  async refreshToken() {
    try {
      const response = await api.post('/auth/refresh');

      if (response.token) {
        api.setToken(response.token);
      }

      return response;
    } catch (error) {
      console.error('Token refresh failed:', error);
      throw error;
    }
  },

  /**
   * 检查是否已登录
   */
  isAuthenticated() {
    return !!api.token;
  },
};
